export class Constants {

    static DepthMapRange = 1 << 16;
    static MemoryPageSize = 65536;
    static BytesPerFloat = 4;
    static BytesPerInt = 4;
    static MaxScenes = 32;
    static StreamingSectionSize = 524288;
    static SphericalHarmonics8BitCompressionRange = 3;
}
